import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from '../../forum/app';
import DefaultResolver from '../../common/resolvers/DefaultResolver';
export default class UserPageResolver extends DefaultResolver {
  canonicalizeUserSlug(slug) {
    if (!slug) return;
    return slug.split('-')[0];
  }
  makeKey() {
    const params = _objectSpread({}, m.route.param());
    params.username = this.canonicalizeUserSlug(params.username);
    return this.routeName + JSON.stringify(params);
  }
  render(vnode) {
    const currentSlug = m.route.param('username');
    const id = this.canonicalizeUserSlug(currentSlug);
    if (id) {
      const user = app.store.getById('users', id);
      if (user && user.slug() && currentSlug !== user.slug()) {
        window.history.replaceState(null, '', app.route(this.routeName, {
          username: user.slug()
        }));
      }
    }
    return super.render(vnode);
  }
}
flarum.reg.add('core', 'forum/resolvers/UserPageResolver', UserPageResolver);